import { AlertTriangle } from "lucide-react";
import type { FC } from "react";

import { Button } from "@/components/ui/button";

import type { Draft } from "../../../api/types/draft";

/**
 * `[GAP: ...]` blanks: placeholders the classic writer left in its own text
 * (`[INSERT ...]`, `{{...}}`), which the docx can't keep as they are.
 */
export const classicBlanks = (draft: Pick<Draft, "content_text">): number =>
  (draft.content_text?.match(/\[GAP\b/g) ?? []).length;

type Props = {
  draft: Draft;
  onRevise: () => void;
};

/** Above a draft Classic wrote: where it came from and what's left to fill. */
export const ClassicStrip: FC<Props> = ({ draft, onRevise }) => {
  const blanks = classicBlanks(draft);
  const source = draft.classic_template_id
    ? "your firm's template"
    : "CaseBlink's classic template";
  return (
    <div
      data-testid="classic-strip"
      className="flex items-center gap-2 border-b border-line-1 bg-fill-1 px-3 py-1.5 text-sm text-fg-2"
    >
      {blanks || draft.classic_letterhead_error ? (
        <AlertTriangle className="size-3.5 shrink-0 text-warn" />
      ) : null}
      <span className="min-w-0 flex-1 truncate">
        <span className="text-fg">Classic draft from {source}</span>
        {blanks
          ? ` · ${blanks} ${blanks === 1 ? "blank" : "blanks"} to fill`
          : ""}
        {draft.classic_letterhead_error
          ? ` · ${draft.classic_letterhead_error}`
          : ""}
      </span>
      <Button variant="ghost" size="xs" onClick={onRevise}>
        Revise With Casey
      </Button>
    </div>
  );
};
